// extracted by mini-css-extract-plugin
module.exports = {"displayArea":"ViewBranches_displayArea__WgbfB","heading":"ViewBranches_heading__3wx1T","allBranches":"ViewBranches_allBranches__3mHm-","addBranch":"ViewBranches_addBranch__6eWiM"};